export const TEXT_SHADOW = {
  RAISED: '--text-shadow-raised',
  DEPRESSED: '--text-shadow-depressed',
  DROP_SHADOW: '--text-shadow-drop_shadow',
} as const
export type TEXT_SHADOW = (typeof TEXT_SHADOW)[keyof typeof TEXT_SHADOW]
